import { Flame, Zap, Award, TrendingUp } from "lucide-react";
import { calculateGameStats } from "../../utils/gameUtils";

const KPIChip = ({ icon: Icon, label, value, color, tooltip }) => (
    <div className="relative group flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white shadow-sm cursor-default">
      <Icon className="w-4 h-4" style={{ color }} />
      <div className="flex items-center gap-2">
        <span className="text-xs text-gray-600">{label}:</span>
        <span className="text-sm font-semibold text-gray-900">{value}</span>
      </div>
      {tooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 shadow-lg">
          {tooltip}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
        </div>
      )}
    </div>
);

export const KPIChips = ({ gameData }) => {
    const stats = calculateGameStats(gameData);
    if (!stats) return null;
    
    const getExcitementColor = (ei) => {
      if (ei >= 75) return "#dc2626";    // red-600 - Instant classic
      if (ei >= 50) return "#f97316";    // orange-500 - Exciting
      if (ei >= 25) return "#f59e0b";    // amber-500 - Competitive
      return "#9ca3af";                    // gray-400 - Routine
    };
    
    return (
      <div className="mb-6">
        <div className="flex flex-wrap gap-2">
          <KPIChip
            icon={Flame}
            label="Excitement"
            value={`${stats.excitementIndex}/100`}
            color={getExcitementColor(stats.excitementIndex)}
          />
          <KPIChip
            icon={Zap}
            label="Biggest Play"
            value={stats.biggestPlay ? `${stats.biggestPlay.batter_name || "Unknown"} · ${(stats.biggestPlay.wpa * 100).toFixed(1)}%` : "N/A"}
            color="#a855f7"
          />
          <KPIChip
            icon={Award}
            label="Game MVP"
            value={stats.mvp ? `${stats.mvp[0]} · ${(stats.mvp[1] * 100).toFixed(1)}%` : "N/A"}
            color="#16a34a"
          />
          <KPIChip
            icon={TrendingUp}
            label="Lead Changes"
            value={stats.leadChanges}
            color="#e11d48"
          />
        </div>
      </div>
    );
  };